import React from 'react';
import "../../style/register.scss";
import DivLanguage from "../../components/DivLanguage";
import AuthForm from "../../components/forms/AuthForm";
import ManualRegisterForm from "../../components/forms/ManualRegisterForm";



const RegisterReavie = () => {


    return (
        <>
            <section >
                <div className="center">

                    <DivLanguage language="fr" className="title center">
                        <h1>
                            REAVIE 2026
                        </h1>
                        <span className="p20-regular">
                        Restons en contact
                    </span>
                    </DivLanguage>
                    <DivLanguage language="en" className="title center">
                        <h1>
                            REAVIE 2026
                        </h1>
                        <span className="p20-regular">
                        Let's stay in touch
                    </span>
                    </DivLanguage>

                </div>
            </section>

            <section >
                <DivLanguage language="fr">


                    <div className="center" style={{maxWidth:'800px'}}>
                        <ManualRegisterForm/>

                        <div className="my-4"/>


                        <h4>Ou se connecter avec:</h4>


                        <div className="auth-form-container my-2">
                            <AuthForm/>
                        </div>




                        <p className="form-privacy my-5">
                            ALPHAWAVE traite les données recueillies pour répondre à vos demandes et pour des actions de prospection
                            commerciale B2B. Pour en savoir plus sur la gestion de vos données personnelles et pour exercer vos
                            droits :{" "}
                            <a href="https://www.alphawave.fr/privacy-policy" target="_blank" rel="noopener noreferrer">
                                Politique de confidentialité
                            </a>
                        </p>
                    </div>



                </DivLanguage>
                <DivLanguage language="en" className="center">
                    <div className="wrapper-demi">

                        <div className="left">
                            <ManualRegisterForm/>
                        </div>

                        <div className="right">
                            <DivLanguage language="en" className="center">
                                <h4>Connect with:</h4>
                            </DivLanguage>
                            <DivLanguage language="fr" className="center">
                                <h4>Se connecter avec:</h4>
                            </DivLanguage>
                            <AuthForm/>
                        </div>
                    </div>
                </DivLanguage>

            </section>



        </>
    )
};

export default RegisterReavie;